<template>
  <base-grid
    class="game-secondary-button-border-color game-tile-radius tw-overflow-hidden game-tile-border collection-stats"
    :class="Classes.STATS"
    :cols="2"
    :x-gap="0"
    :y-gap="0"
  >
    <view-stat
      icon="star"
      format-number
      :title="$t('followers')"
      :text="collection?.stats.followers_total"
      :panel-loading="panelLoading"
    />

    <view-stat
      :icon="collection?.platforms?.length ? null : 'layer-group'"
      :title="
        collection?.platforms?.length
          ? $t('platforms', 2)
          : $t('ugc_count', { ugc: ugcName(game, true).value })
      "
      :platforms="collection?.platforms"
      :text="collection?.stats.mods_total"
      :panel-loading="panelLoading"
    />
  </base-grid>
</template>

<script>
import ViewStat from '@components/View/ViewStat.vue'
import { useResourceValue } from '@composables'
import Classes from '@shared/js/config/css.js'
export default {
  components: {
    ViewStat,
  },
  props: {
    collection: {
      type: Object,
      default: null,
    },
    game: {
      type: Object,
      default: null,
    },
    panelLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { ugcName } = useResourceValue()

    return {
      ugcName,
      Classes,
    }
  },
}
</script>

<style>
.stats {
  div.section {
    border-right: var(--tile-border-width) solid var(--tile-border-color);
  }

  div.section:nth-child(2) {
    border-right: none;
  }
}

.collection-stats {
  border-bottom: 0;
}
</style>
